// Row dimensions
export const LIST_ROW_HEIGHT = 40
export const LIST_HEADER_HEIGHT = 28

// Sub-header row (column headers shown when expanding into a child level)
export const SUB_HEADER_HEIGHT = 28

// Add record row at the bottom of each group
export const ADD_ROW_HEIGHT = 36

// Indentation per depth level
export const INDENT_PER_DEPTH = 28

// Chevron column (fixed left area for expand/collapse + indent)
export const CHEVRON_COL_WIDTH = 40

// Chevron / expand-collapse toggle
export const CHEVRON_SIZE = 16
export const CHEVRON_MARGIN_RIGHT = 8

// Gaps between depth transitions (rendered in useCanvasRender)
export const DEPTH_INCREASE_GAP = 8
export const DEPTH_DECREASE_GAP = 16

// Cell padding
export const CELL_PADDING = 10

// Column resize
export const RESIZE_HANDLE_WIDTH = 8
export const MIN_COLUMN_WIDTH = 80

// Default column width
export const DEFAULT_COLUMN_WIDTH = 180

// Default width for the first (display) field
export const DEFAULT_FIRST_COLUMN_WIDTH = 300

// Bottom padding after the last row
export const BOTTOM_PADDING = 240

// Right padding after the last column
export const RIGHT_PADDING = 120

// Data fetch chunk size (shared between useDataFetch and useCanvasListView)
export const CHUNK_SIZE = 50
